import React, {Component} from "react";  import config from 'react-global-configuration';
import "react-tabs/style/react-tabs.css";
import jwt_decode from "jwt-decode";
import axios from "axios";
import $ from "jquery";
import Select from 'react-select';
import {css} from "@emotion/core";
import { List } from 'react-virtualized';
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import * as moment from "moment";
import ModalD from "react-awesome-modal";

import {connect}  from  "react-redux";
import {BeatLoader} from "react-spinners";
import {confirmAlert} from 'react-confirm-alert';
import { isApiResponse, isReportAccess, date_range_config, aplloClient,user_activities } from '../../helpers/utils.js';
import DownloadAllReport from '../DownloadReport/DownloadAllReport.jsx';
import MerchantFilter from '../../filters/MerchantFilter.jsx';
import ChainFilter from '../../filters/ChainFilter.jsx';
import StoreFilter from '../../filters/StoreFilter.jsx';
import UtidFilter from '../../filters/UtidFilter.jsx';
import DateRangeFilter from '../../filters/DateRangeFilter.jsx';
const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
    text-align:center;
`;

var date_config = date_range_config('0', '0', '2020-02-01','0');
var UtidSummaryTable='';


class GenieAcquisitionReport extends Component{
    constructor(props) {
        super(props);
        this.state ={
            datefrom:date_config.start_date,
            dateTo:date_config.end_date,
            datefromShow:date_config.display_start_date,
            dateToShow:date_config.display_end_date,
            yestSend:date_config.start_date_value,
            todSend:date_config.end_date_value,
            dateFromLimit: date_config.start_date_limit,
            dateLimit:date_config.end_date_limit,
            merchantList:[],
            chainList:[],
            merchantID:'',
            chainID:'',
            storeID:'',
            merchantValue:null,
            chainValue:null,
            storeList:[],
            acqBankList:[],
            acqBankValue: null,
            acqBankIds:'',
            issuerBankList:[],
            issuerBankValue:null,
            issuerBankIds:'',
            cityLists:[],
            cityValue:null,
            cityIds:'',
            loading:false,
            is_void:1,
            model_visible : false,
            file_url: '',
            rfile: '',
            merchant_list_box: false,
            chain_list_box: false,
            store_list_box: false,
            acq_bank_list_box: false,
            txnLists:[{value:'Leg1 QR Transaction', label: 'Leg1'},{value:'Leg2 QR Transaction', label: 'Leg2'}],
            txnValue:'',
            txnIds:'',
            is_store_loading: true,
            is_chain_loading: true,
            is_merchant_loading: true,
            txnTypeLists: [{value: 'all', label: 'All'}, {value: 'SALE', label: 'SALE'}, {
                value: 'VOID',
                label: 'VOID'
            }, {
                value: 'REVERSAL',
                label: 'REVERSAL'
            },{
                value: 'FAILED',
                label: 'FAILED'
            }],
            txnTypeIDs: ['SALE'],
            txnTypeValue: [{value: "SALE", label: "SALE"}],
            ciutidList: [],
            ciutidValue: null,
            ciutidIds: '',
            is_utid_loading: true,
            isSettledLists: [{value: 'Settled', label: 'Settled'},{value: 'Unsettled', label: 'Unsettled'},{value: 'Reversal', label: 'Reversal'}, {value: 'Void', label: 'Void'},{value: 'Failed', label: 'Failed'}],
            isSettledIDs: '',
            isSettledValue: null,
            isChange: false,
            is_posbillinput: 0,
            is_prim_id:0,
            listOpen: false,
            headerTitle: "Select [Utid]",
            storeListOpen: false,
            storeHeaderTitle: "Select [Store]",
            object_code:[],
            storeObject:[],
            search_object_code:[],
            fetch_data:false
        }

    }
    componentWillMount() {
        this.props.currentMenu("unipaynext");
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        const tokenPermission = localStorage.userPermission;
        const decoded_permission = jwt_decode(tokenPermission);
        let AllAccessPermissions = decoded_permission.accessPermissions;
        var stringCode = decoded.object_code;
        var arrayCode = stringCode.split(",");
        isReportAccess(AllAccessPermissions, "genie_acquisition_report");
        if(decoded.object_type==='Merchant'){
            this.setState({
                merchantID: arrayCode
            })
        }
        if(decoded.object_type==='Chain'){
            this.setState({
                chainID: arrayCode
            })
        }
        if(decoded.object_type==='Store'){
            this.setState({
                storeID: arrayCode
            })
        }

        this.setState({
            user_id:decoded._id,
            object_type: decoded.object_type,
            object_code: arrayCode,
            userType: decoded.userType,
        });
    }

    componentDidUpdate() {
     }
    componentDidMount() {
        this.get_filtered_utid_summary_report(this.state.object_type,this.state.object_code,'');
        //user_activities(0, jwt_decode(localStorage.usertoken)._id, jwt_decode(localStorage.usertoken).firstName+' '+jwt_decode(localStorage.usertoken).lastName, jwt_decode(localStorage.usertoken).email,'genie_acquisition_report','sparcs')
    }

    get_filtered_utid_summary_report(object_type, object_code, event) {
        var that = this;


        isApiResponse(false)
        var merchants = this.state.merchantID;
        var chains = this.state.chainID;
        var stores = this.state.storeID;
        if(object_type === 'Merchant' && this.state.merchantID===''){
            merchants = object_code;
        }
        if(object_type==='Chain' && this.state.chainID===''){
            chains = object_code;
        }
        if(object_type==='Store' && this.state.storeID===''){
            stores = object_code;
        }
        this.setState({
            active_mids: merchants,
            active_cids: chains,
            active_sids: stores,
            active_bids: this.state.acqBankIds,
            active_cityids: this.state.cityIds,
            active_transaction_type: this.state.txnTypeIDs,
            active_yestSend: this.state.yestSend,
            active_todSend: this.state.todSend,
            active_utid: this.state.ciutidIds,
            active_is_settled: this.state.isSettledIDs,
            active_txnIds: this.state.txnIds,
            active_is_prim_id: this.state.is_prim_id,
            active_is_posbillinput: this.state.is_posbillinput,
        })
        var postData = {
            mids: merchants,
            cids: chains,
            sids: stores,
            yestSend: this.state.yestSend,
            todSend: this.state.todSend,
            utid: this.state.ciutidIds,

        };
        if ($.fn.DataTable.isDataTable('#GenieAcqTabe')) {
            $('#GenieAcqTabe').DataTable().clear().destroy();
        }
        var GenieAcqTabe = $('#GenieAcqTabe').DataTable(
            {
                order:[],
                "processing": true,
                "serverSide": true,
                "bDestroy": true,
                "paging": true,
                "pageLength": 20,
                "bInfo" : false,
                "sPaginationType": "numbers",
                "autoWidth": false,
                //"responsive": false,
                "scrollX": true,
                "lengthMenu": [[20, 50, 100, 500 -1], [20, 50, 100, 500, "All"]],
                ajax: {
                    url:config.get('API_URL')+ "/InternalReport/genie-acquisition-report",
                    type: "POST",
                    data: postData,
                    dataSrc:function ( json ) { //console.log("amondon"); console.log(json);
                        isApiResponse(true)
                        that.setState({
                            isChange: false
                        })
                        return json.data;
                    },
                    beforeSend: function(request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                    error: function (data) {
                        isApiResponse(true);
                        alert("Failed to load data. Please try again");
                    },
                    complete: function (data) {
                        isApiResponse(true)
                    },
                },

                columns: [
                    {"data":"opp_gst_number"},
	 {"data":"gor_entry_timestamp"},
	 {"data":"gst_number"},
	 {"data":"address"},
	 {"data":"mobile_number"},
	 {"data":"email_id"},
	 {"data":"pan_number"},
	 {"data":"terminal_serial_no"},
	 {"data":"utid"},
	 {"data":"utid_created_timestamp"},
	 {"data":"onboarding_tat"},
	 {"data":"muhutra_txn"},
	 {"data":"muhutra_tat_timestamp"},
	 {"data":"creating_first_profile_timestamp"},
	 {"data":"first_price_match_timestamp"},
	 {"data":"training_complete_timestamp"},
	 {"data":"no_of_days_since_on_tap"},
	 {"data":"marketing_day_1_timestamp"},
	 {"data":"marketing_day_3_timestamp"},
	 {"data":"marketing_day_7_timestamp"},
	 {"data":"marketing_day_15_timestamp"},
	 {"data":"asm_visit_day_1_timestamp"},
	 {"data":"asm_visit_day_3_timestamp"},
	 {"data":"asm_visit_day_7_timestamp"},
	 {"data":"asm_visit_day_15_timestamp"},
	 {"data":"payment_collected_status"},
// 	 {"data":"sales_person_id"}

                ],
                "columnDefs": [
                    {  render: function (data) {
                            if(data==null || data=='null' ||data==""){
                                return '<td > </td>';
                            } else {
                                return '<td >'+moment(data).format('D MMM YYYY HH:mm:ss')+'</td>';
                            }

                        },
                        "width": "80px",
                        "targets": [1,9,11,13,14,15,17,18,19,20,21,22,23,24]
                    },
                    {
                        render: function (data, type, full, meta) {
                            if(data===null || data===''|| data ==='null'){
                            data = '';
                            }
                            return "<div class='text-wrap width-150'>" + data + "</div>";
                        },
                        "targets": [3]
                    },

                ],

            });

    }

    genieAcuDownloadCheck(e){
        let filters = {
            end_date: this.state.todSend,
            start_date: this.state.yestSend,
            utid: this.state.ciutidIds,
            download: 1
        }
        this.setState({
            filters:filters
        })
        if(this.state.merchantID==='' && this.state.chainID==='' && this.state.storeID==='' && this.state.ciutidIds===''){
            confirmAlert({
            //title: 'Warning',
                message: "Do you really want to download all data for date range: "+this.state.datefromShow+" - "+this.state.dateToShow+" ? This will take some time to download depending on volume of data. Alternatively, please apply a filter.",
                buttons: [{
                    label: 'OK',
                    onClick: () => {
                        this.refs.downloadAllReport.downLoadReport(filters, '/internal_reports/genie-acquisition-report','genie_acquisition_report', 30);
                    }
                },
                    {
                        label: 'Cancel',
                    }
                ]
            });
        } else {
            this.refs.downloadAllReport.downLoadReport(filters, '/internal_reports/genie-acquisition-report','genie_acquisition_report', 30);
        }
    }

    reset_all(e){
        this.refs.daterangeFilter.restDateFilter(date_config.start_date,date_config.end_date,date_config.display_start_date, date_config.display_end_date, date_config.start_date_value,date_config.end_date_value);
        this.refs.reloadUtid.ci_utid('','','',false,'');
        this.setState({
            ciutidValue: [],
            ciutidIds: '',
            datefrom:date_config.start_date,
            dateTo:date_config.end_date,
            datefromShow:date_config.display_start_date,
            dateToShow:date_config.display_end_date,
            yestSend:date_config.start_date_value,
            todSend:date_config.end_date_value,
            merchantID:'',
            chainID:'',
            storeID:'',
            storeValue:[],
            merchantValue:[],
            chainValue:[],
            acqBankValue: [],
            acqBankIds:'',
            issuerBankValue:[],
            issuerBankIds:'',
            cityValue:[],
            cityIds:'',
            is_void:1,
            file_url: '',
            rfile: '',
            cardGradeValue:[],
            cardGradeIDs:'',
            schemeValue:[],
            schemeIDs:'',
            cardTypeValue:[],
            cardTypeIDs:'',
            txnissuerValue:[],
            txnissuerIDs:'',
            emiIssuerValue:[],
            emiIssuerIDs:'',
            txnTypeIDs: ['SALE'],
            txnTypeValue: [{value: "SALE", label: "SALE"}],
            ciutidValue: [],
            ciutidIds: '',
            isSettledIDs: '',
            isSettledValue: [],
            isChange: false,
            is_posbillinput: 0,
            is_prim_id:0,
            tenderModeIDs:'',
            tenderModeValue:[],
            is_fallback: 0,
            traCurrencyValue:[],
            traCurrencyIDs:'',
            issuHomeCurrValue:[],
            issuHomeCurrIDs:'',
            campaignCodeValue:[],
            campaignCodeIDs:'',
            txnIds:'',
            txnValue:[],
        })

        setTimeout(function(){
            this.componentDidMount()
        }.bind(this), 200);
    }
    handleDateRange = (todSend, yestSend, datefromShow,dateToShow) =>
    {
        this.setState({
            todSend: todSend,
            yestSend: yestSend,
            datefromShow: datefromShow,
            dateToShow: dateToShow,
            isChange: true,
        });


    }
    handleMerchant = (optionSelected, merchantID) =>
    {
        this.setState({
            merchantID:merchantID,
            isChange: true,
            chainID:'',
            storeID:'',
            ciutidIds: '',
        });
        this.refs.reloadChain.getChain(merchantID, 'merchant', this.state.object_type, this.state.object_code);
        this.refs.reloadStore.getStore(merchantID, 'merchant', this.state.object_type, this.state.object_code,false,'');
        this.refs.reloadUtid.ci_utid(merchantID, '','',false,'');
    }
    handleChain = (optionSelected, chainID) =>
    {
        this.setState({
            chainID:chainID,
            isChange: true,
            storeID:'',
            ciutidIds: '',
        });
        this.refs.reloadStore.getStore(chainID, 'chain', this.state.object_type, this.state.merchantID,false,'');
        this.refs.reloadUtid.ci_utid(this.state.merchantID, chainID,'',false,'');
    }

    handleStore = (storeID) =>
    {
        this.setState({
            storeID:storeID,
            isChange: true,
            ciutidIds: '',

        });
        this.refs.reloadUtid.ci_utid(this.state.merchantID, this.state.chainID,storeID,false,'');
    }
    handleUtid = (utid) =>
    {
        this.setState({
            ciutidIds:utid,
            isChange: true
        });

    }

    render() {
        return(

            <div className="content-invoice">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="col-md-9 no-padd">
                                    <div className="header">
                                        <h4 className="title">Genie Acquisition Report</h4>
                                        <p className="category"></p>
                                    </div>
                                </div>
                                <div className="col-md-3 pull-right">
                                    <div className="r-p-menu">
                                        {/*<SalesMenu></SalesMenu>*/}
                                    </div>
                                </div>
                                <div className = "clearfix"></div>
                                <div className = "content">
                                    <div className="row">
                                        <div className="col-md-12 filter-border-right">
                                        <div className="col-md-2 filter-bottom5 padd-5 date-icon-small">
                                            <div><label>UTID Created Date : </label></div>
                                            <DateRangeFilter ref="daterangeFilter" onSelectDate = {this.handleDateRange} start_date = {this.state.datefrom} end_date={this.state.dateTo} display_start_date = {this.state.datefromShow} display_end_date = {this.state.dateToShow}
                                                start_date_limit = {this.state.dateFromLimit} end_date_limit = {this.state.dateLimit}/>
                                        </div>


                                            <div className="col-md-2 filter-bottom5 padd-5" >
                                                <label> Utid: </label>
                                                <UtidFilter ref = "reloadUtid" onSelectUtid = {this.handleUtid} object_type = {this.state.object_type} object_code={this.state.object_code} user_type = {this.state.userType}/>
                                                <div className="clearfix"></div>
                                            </div>


                                    </div>

                                    </div>
                                    <div className="row">
                                        <div className="col-md-5 pull-right">
                                            {this.state.isChange===true?
                                                <span className="apply-notification">Please click on Apply button</span>:null
                                            }
                                            <button type="button" className="primary apply-filter" role="button" disabled={!this.state.isChange} onClick={this.get_filtered_utid_summary_report.bind(this, this.state.object_type,this.state.object_code)}>Apply</button>
                                            &nbsp; &nbsp;<button type="button" className="primary reset-filter" role="button"  onClick={this.reset_all.bind(this)}>Reset</button>
                                        </div>
                                    </div>

                                    <div className="clearfix"></div>
                                    <div className="row">
                                        <div className="ro-sep"></div>
                                    </div>
                                    <div className="">
                                        <a href="#" className="exportButton" role="button" onClick={this.genieAcuDownloadCheck.bind(this)}>
                                            <i className="fa fa-download" aria-hidden="true"></i>
                                            Export to CSV
                                        </a>
                                    </div>
                                    <div className="clearfix"></div>
                                    <div className="content-tdetails-table table-full-width table-responsive marginTop0">
                                        <table id="GenieAcqTabe" className="table table-striped table-hover">
                                            <thead>
                                                <tr>
                                                    <th>Opp GST Number</th>
                                                    <th>GOR Entry Timestamp</th>
                                                    <th>GST Name</th>
                                                    <th>Address</th>
                                                    <th>Mobile Number</th>
                                                    <th>Email ID</th>
                                                    <th>PAN Number</th>
                                                    <th>Terminal Serial Number</th>
                                                    <th>UTID</th>
                                                    <th>UTID Created Timestamp</th>
                                                    <th>Onboarding TAT</th>
                                                    <th>Muhurat TXN Timestamp</th>
                                                    <th>Muhurat TAT </th>
                                                    <th>Creating First Profile Timestamp</th>
                                                    <th>First Price Match Timestamp</th>
                                                    <th>Training Complete Timestamp</th>
                                                    <th>No of Days Since On TAP</th>
                                                    <th>Marketing Day 1 Timestamp</th>
                                                    <th>Marketing Day 3 Timestamp</th>
                                                    <th>Marketing Day 7 Timestamp</th>
                                                    <th>Marketing Day 15 Timestamp</th>
                                                    <th>ASM Visit Day 1 Timestamp</th>
                                                    <th>ASM Visit Day 3 Timestamp</th>
                                                    <th>ASM Visit Day 7 Timestamp</th>
                                                    <th>ASM Visit Day 15 Timestamp</th>
                                                    <th>Payment Collected Status</th>
{/*                                                     <th>Sales Person ID</th> */}
                                                </tr>
                                            </thead>
                                            <tbody>

                                            </tbody>
                                        </table>
                                    </div>
                                    <DownloadAllReport ref="downloadAllReport" />
                                    <div className="footer">
                                        <div className="stats"><i></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

             );
    }
}

const mapDispatchToProps = (dispatch) =>{
    return {
    currentMenu: (name)=>{dispatch({type:'change_menu',payload:name})}
    }
  }
  export default connect(null,mapDispatchToProps)( GenieAcquisitionReport );